import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_NOTE_INSERT, TICKET_LIST_ALL_NOTE_INSERT_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import IconAddNote from '../../assets/icons/IconAddNote';
import Alert from '../Alert/Alert';
import ActionType from '../../redux/reducer/globalActionType';

class TicketNote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            note: '',
            showNoteModal: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            note: this.state.note,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataUpdateNote(data, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showNoteModal: false,
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                this.props.refresh();
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false
        return true
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_NOTE_INSERT, TICKET_LIST_ALL_NOTE_INSERT_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btnnote" className={(this.props.data.status === STATUS_TICKET_CONSTANT.ASSIGNED || this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS || this.props.data.status === STATUS_TICKET_CONSTANT.ON_HOLD) && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) && this.checkCustomerServiceAssignee() ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1" : "hidden"} onClick={() => this.setState({ showNoteModal: !this.state.showNoteModal })}>
                    <IconAddNote />
                    <span className="mx-1">Tambah Note</span>
                </button>

                <div className={this.state.showNoteModal ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/2">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnnoteclose" onClick={() => this.setState({ showNoteModal: false })} />
                            </div>
                            <form onSubmit={this.handleSubmit}>
                                <p className="text-darkblue text-center text-3xl font-medium">Tambah Note</p>
                                <textarea id="tmlnote" className="form-control resize-none h-96 my-5" placeholder="Masukan Note" name="note" value={this.state.note} onChange={this.handleChange} maxLength="256" />
                                <div className="flex justify-center items-center">
                                    <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.setState({ showNoteModal: false })}>Batal</button>
                                    <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2">Simpan</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil disimpan!" />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketNote);